import React from 'react';
import { ModalBody } from '../CommonComponents/OPL/Modal/ModalBody';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { ErrorState } from '../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';

interface Props {
  onRetry(): void;
}

export const TwoFactorAuthenticationError = ({ onRetry }: Props) => {
  return (
    <ModalBody>
      <Box p={48}>
        <ErrorState onAction={onRetry} />
      </Box>
    </ModalBody>
  );
};
